import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconBackward7 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.594 17.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.571,16.985 C23.540,17.512 23.109,17.921 22.591,17.921 C22.582,17.921 22.572,17.921 22.563,17.921 C22.032,17.906 21.609,17.467 21.608,16.929 C21.607,16.865 21.559,15.167 20.071,13.774 C18.708,12.498 16.582,11.879 13.750,11.920 L13.750,14.936 C13.750,15.339 13.511,15.701 13.144,15.856 C13.022,15.907 12.895,15.931 12.768,15.931 C12.512,15.931 12.262,15.830 12.074,15.640 L5.198,8.673 C4.814,8.285 4.814,7.655 5.198,7.267 L12.074,0.301 C12.355,0.015 12.775,-0.070 13.144,0.085 C13.511,0.239 13.750,0.601 13.750,1.004 L13.750,4.113 C14.810,4.294 16.629,4.742 18.437,5.862 C20.983,7.437 23.939,10.645 23.571,16.985 ZM12.708,5.978 C12.654,5.974 12.608,5.949 12.557,5.937 C12.489,5.921 12.420,5.912 12.358,5.883 C12.305,5.858 12.264,5.820 12.217,5.786 C12.160,5.746 12.102,5.711 12.055,5.660 C12.016,5.618 11.992,5.567 11.961,5.519 C11.923,5.460 11.882,5.406 11.857,5.340 C11.836,5.284 11.833,5.223 11.822,5.163 C11.810,5.103 11.786,5.048 11.786,4.984 L11.786,3.407 L7.281,7.970 L11.786,12.533 L11.786,10.956 C11.786,10.897 11.809,10.847 11.819,10.791 C11.830,10.725 11.834,10.658 11.857,10.597 C11.880,10.537 11.918,10.489 11.952,10.435 C11.986,10.380 12.014,10.324 12.057,10.277 C12.100,10.231 12.153,10.200 12.204,10.163 C12.256,10.125 12.302,10.083 12.361,10.056 C12.419,10.029 12.484,10.021 12.548,10.005 C12.602,9.992 12.651,9.966 12.709,9.962 C16.294,9.744 19.079,10.413 20.992,11.954 C18.994,6.457 13.021,5.998 12.708,5.978 ZM2.370,7.970 L8.552,14.232 C8.935,14.621 8.935,15.251 8.552,15.640 C8.360,15.834 8.108,15.931 7.857,15.931 C7.606,15.931 7.354,15.834 7.163,15.640 L0.287,8.673 C-0.097,8.285 -0.097,7.655 0.287,7.267 L7.163,0.301 C7.546,-0.088 8.168,-0.088 8.552,0.301 C8.935,0.689 8.935,1.319 8.552,1.708 L2.370,7.970 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconBackward7.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
